import classnames from "@src/utils/classnames"
import React from "react"
import Container from "../container"
import ResponsiveImage from "../responsiveContent/image"
import * as styles from "./block.module.scss"

const Block = React.forwardRef(
  ({ title, className, children, append, ...restProps }, ref) => {
    return (
      <div
        className={classnames(
          styles.block,
          {
            [styles.blockNoTitle]: !title,
          },
          className
        )}
        ref={ref}
        {...restProps}
      >
        <Container>
          {title && (
            <h2 className={styles.title}>
              <ResponsiveImage pc={title[0]} mobile={title[1]} />
            </h2>
          )}
          {children}
        </Container>
        {append}
      </div>
    )
  }
)

export default Block
